import React, { useState, useEffect } from 'react';
import { Form, Input, Card } from 'antd';
import { useTranslation } from 'react-i18next';

const { TextArea } = Input;

interface CredentialSettingsProps {
  form: any;
}

// Custom TextArea that handles \n conversion internally
const CredentialTextArea: React.FC<any> = ({ value, onChange, ...props }) => {
  const [displayValue, setDisplayValue] = useState<string>('');

  // Convert \n to newlines for display
  useEffect(() => {
    if (value) {
      setDisplayValue(value.replace(/\\n/g, '\n'));
    }
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const inputValue = e.target.value;
    setDisplayValue(inputValue);
    
    // Convert newlines to \n and call onChange
    const storageValue = inputValue.replace(/\n/g, '\\n');
    onChange?.(storageValue);
  };

  return (
    <TextArea
      {...props}
      value={displayValue}
      onChange={handleChange}
    />
  );
};

const CredentialSettings: React.FC<CredentialSettingsProps> = ({ }) => {
  const { t } = useTranslation();
  
  return (
    <Card title={t('settings.credentialFormat.title')} variant="outlined">
      <Form.Item
        name="credentialFormat"
        label={t('settings.credentialFormat.credentialCopy')}
        rules={[{ required: true }]}
        initialValue="Usuario: {username}\\nClave: {password}"
        help={t('settings.credentialFormat.placeholder')}
      >
        <CredentialTextArea rows={4} />
      </Form.Item>
      <p>{t('settings.credentialFormat.previewDescription')}</p>
    </Card>
  );
};

export default CredentialSettings;